import { Route, Routes } from 'react-router-dom';
import { ContactPage } from '../Pages/ContactPage';

export const ContactRoutes = () => (
  <Routes>
    <Route path="contact" element={<ContactPage />} />
  </Routes>
);
